// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { AfterViewInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { RolesFacadeService } from '@app/access-management/state/roles.facade';
import { readParameterFromRouterState, GoAction } from '@app/core';
import { ActivatedRoute } from '@angular/router';
import { OrganizationDetailsFacadeService } from '@app/access-management/state/organization-details/organization-details.facade';
import { SelectRoleAction } from '@app/access-management/state';
var OrganizationRolesListComponent = /** @class */ (function () {
    function OrganizationRolesListComponent(store, activatedRoute, organizationDetailsFacade, roleFacade) {
        this.store = store;
        this.activatedRoute = activatedRoute;
        this.organizationDetailsFacade = organizationDetailsFacade;
        this.roleFacade = roleFacade;
        this.columns = [];
        this.organizationId = '';
        this.organizationId = readParameterFromRouterState(this.activatedRoute, 'orgId');
        if (!this.organizationId) {
            throw new Error('organization id not in route');
        }
        this.roleFacade.loadOrganizationRoles(this.organizationId);
        this.organizationDetailsFacade.initialize(this.organizationId);
        this.organization$ = this.organizationDetailsFacade.organization$;
    }
    OrganizationRolesListComponent.prototype.ngAfterViewInit = function () {
        this.columns = [
            {
                name: 'Role Name',
                prop: 'name',
                cellClass: 'text-info',
                flexGrow: 2
            },
            {
                name: 'Users',
                prop: 'numberOfUsers',
                flexGrow: 1
            },
            {
                name: 'Description',
                prop: 'description',
                flexGrow: 2
            },
            {
                name: 'Category',
                prop: 'category',
                flexGrow: 1
            }
        ];
    };
    OrganizationRolesListComponent.prototype.onRowClicked = function (_a) {
        var selected = _a.selected;
        if (selected.length < 1) {
            return;
        }
        var selectedRole = selected[0];
        this.store.dispatch(new SelectRoleAction(selectedRole));
        this.store.dispatch(new GoAction(['/iam/organizations/' + this.organizationId + '/roles/', selectedRole.id]));
    };
    return OrganizationRolesListComponent;
}());
export { OrganizationRolesListComponent };



// WEBPACK FOOTER //
// ./src/app/access-management/organizations/organization-roles-list/organization-roles-list.component.ts.pre-build-optimizer.js